import api from "@/lib/api";

export const apiGet = (path, params) => api.get(path, { params }).then((r) => r.data);
export const apiPost = (path, data) => api.post(path, data).then((r) => r.data);
export const apiPatch = (path, data) => api.patch(path, data).then((r) => r.data);
export const apiDelete = (path) => api.delete(path).then((r) => r.data);
